<div class="container-fluid">
  <form [formGroup]="myFormContrato" (ngSubmit)="onSubmit()">
    <div class="row paddingContainer">
      <ng-template mat-tab-label>
        {{ "cebe.generalData.contractData.title" | translate }}
      </ng-template>
      <div class="col-md-6">
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.client" | translate
          }}</mat-label>
          <input
            type="hidden"
            formControlName="cebeID"
            [value]="myFormContrato.get('cebeID').value"
          />
          <input
            type="hidden"
            formControlName="id"
            [value]="myFormContrato.get('id').value"
          />
          <input
            matInput
            type="text"
            [value]="contract?.cliente | translate"
            class="dataInput"
            formControlName="cliente"
            [readonly]="!this.cebe.edicionCebe"
          />
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.partner" | translate
          }}</mat-label>
          <input
            matInput
            type="text"
            [value]="contract?.socio | translate"
            class="dataInput"
            formControlName="socio"
          />
          <!-- [readonly]="!this.cebe.edicionCebe" -->
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.participacion" | translate
          }}</mat-label>
          <input
            matInput
            type="number"
            min="0.00"
            max="100.00"
            step="0.01"
            [value]="contract?.participacion"
            class="dataInput"
            formControlName="participacion"
            [readonly]="!this.cebe.edicionCebe"
            twoDecimalNumber
          />
          <mat-error
            *ngIf="
              (myFormContrato.get('participacion').hasError('max') ||
                myFormContrato.get('participacion').hasError('min')) &&
              myFormContrato.get('participacion').touched
            "
          >
            {{ "messages.maxminValue" | translate }}
          </mat-error>
        </div>
      </div>
      <div class="col-md-6">
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.contractInit" | translate
          }}</mat-label>
          <div class="datepicker-container">
            <input
              matInput
              [matDatepicker]="pickerContratoInicio"
              formControlName="contratoInicio"
              [disabled]="!this.cebe.edicionCebe"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerContratoInicio"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerContratoInicio></mat-datepicker>
          </div>
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.contractEnd" | translate
          }}</mat-label>
          <div class="datepicker-container">
            <input
              matInput
              [matDatepicker]="pickerContratoFin"
              formControlName="contratoFin"
              [disabled]="!this.cebe.edicionCebe"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerContratoFin"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerContratoFin></mat-datepicker>
          </div>
        </div>
        <div class="inputBlock">
          <mat-label>{{
            "cebe.generalData.contractData.renewalEnd" | translate
          }}</mat-label>
          <div class="datepicker-container">
            <input
              matInput
              [matDatepicker]="pickerProrrogaFin"
              [matDatepickerFilter]=""
              formControlName="prorrogaFin"
              [disabled]="!this.cebe.edicionCebe"
            />
            <mat-datepicker-toggle matSuffix [for]="pickerProrrogaFin">
            </mat-datepicker-toggle>
            <mat-datepicker #pickerProrrogaFin></mat-datepicker>
          </div>
        </div>
        
      </div>
    </div>

    <div class="row paddingContainer">
      <mat-label>{{
        "cebe.generalData.contractData.energy" | translate
      }}</mat-label>

      <div class="col inputBlock select-container inputRow">
        <mat-label>{{
          "cebe.generalData.contractData.energyPayments" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="pagoElectricidadID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of pagoElectricidadList"
            [value]="item.id"
          >
            {{ "energy.payments." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div
        class="col inputBlock select-container instContratacionSuministroElectrico inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.energyContracts" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="contratoElectricidadID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of contratoElectricidadList"
            [value]="item.id"
          >
            {{ "energy.contracts." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div
        class="col inputBlock select-container instTitularidadExportacionEnergia inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.energyExports" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="titularidadEnergiaID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of titularidadEnergiaList"
            [value]="item.id"
          >
            {{ "energy.payments." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div
        class="col inputBlock select-container instPagoSuministroCombustibles inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.fuelPayments" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="pagoCombustibleID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of pagoCombustibleList"
            [value]="item.id"
          >
            {{ "energy.payments." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div
        class="col inputBlock select-container instPagoSuministroCombustVehiculos inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.vehiclesFuel" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="pagoCombustibleVehiculosID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of pagoCombustibleVehiculosList"
            [value]="item.id"
          >
            {{ "energy.payments." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="row paddingContainer">
      <mat-label>{{
        "cebe.generalData.contractData.residues" | translate
      }}</mat-label>
      <div
        class="col inputBlock select-container instTitularidadGestionResiduos inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.wasteOwnerShip" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="titularResiduosDesbasteID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of titularResiduosDesbasteList"
            [value]="item.id"
          >
            {{ "energy.residues." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div
        class="col inputBlock select-container instTitularidadGestionLodos inputRow"
      >
        <mat-label>{{
          "cebe.generalData.contractData.ownershipDehydrated" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="titularFangosID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option *ngFor="let item of titularFangosList" [value]="item.id">
            {{ "energy.residues." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col inputBlock select-container inputRow">
        <mat-label>{{
          "cebe.generalData.contractData.hazardousOwnership" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="titularResiduosPeligrososID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of titularResiduosPeligrososList"
            [value]="item.id"
          >
            {{ "energy.residues." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>

      <div class="col inputBlock select-container inputRow">
        <mat-label>{{
          "cebe.generalData.contractData.nonHazardousOwnership" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="titularResiduosNoPeligrososID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of titularResiduosNoPeligrososList"
            [value]="item.id"
          >
            {{ "energy.residues." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="row paddingContainer instReactivos">
      <mat-label>{{
        "cebe.generalData.contractData.reactives" | translate
      }}</mat-label>

      <div class="col inputBlock select-container instReactivos inputRow">
        <mat-label>{{
          "cebe.generalData.contractData.chemicalAdquisition" | translate
        }}</mat-label>
        <mat-select
          class="dataInput"
          formControlName="adquisicionReactivosID"
          [disabled]="!this.cebe.edicionCebe"
        >
          <mat-option
            *ngFor="let item of adquisicionReactivosList"
            [value]="item.id"
          >
            {{ "energy.payments." + item.codigo | translate }}
          </mat-option>
        </mat-select>
      </div>
    </div>

    <div class="row paddingContainer">
      <div class="col-md-6">
        <div class="checkBlock instcheck-puestaEnMarcha justify-content-end">
          <mat-label class="checkBoxPanel">
            {{ "cebe.generalData.contractData.startup" | translate }}
          </mat-label>
          <mat-slide-toggle
            (change)="showPM_OM()"
            [checked]="contract?.puestaMarcha"
            color="warn"
            formControlName="puestaMarcha"
            [disabled]="!this.cebe.edicionCebe"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-6">
        <div class="inputBlock instFechaPuestaEnMarcha">
          <mat-label>{{
            "cebe.generalData.contractData.dateStartup" | translate
          }}</mat-label>
          <div class="datepicker-container instFechaPuestaEnMarcha">
            <input
              matInput
              class="dateInput"
              [matDatepicker]="pickerPuestaMarcha"
              formControlName="puestaMarchaFecha"
              [disabled]="!this.cebe.edicionCebe"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerPuestaMarcha"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerPuestaMarcha></mat-datepicker>
          </div>
        </div>
        <div class="inputBlock instResponsablePagoPM select-container">
          <mat-label>{{
            "cebe.generalData.contractData.responsibleElecPayment" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="resPagoElecPmID"
            [disabled]="!this.cebe.edicionCebe"
          >
            <mat-option
              *ngFor="let item of titularidadEnergiaList"
              [value]="item.id"
            >
              {{ "energy.payments." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>

    <div class="row paddingContainer">
      <div class="col-md-6">
        <div class="checkBlock instcheck-faseOM justify-content-end">
          <mat-label class="checkBoxPanel">{{
            "cebe.generalData.contractData.phaseOm" | translate
          }}</mat-label>
          <mat-slide-toggle
            (change)="showPM_OM()"
            [checked]="contract?.faseOM"
            color="warn"
            formControlName="faseOM"
            [disabled]="!this.cebe.edicionCebe"
          >
          </mat-slide-toggle>
        </div>
      </div>
      <div class="col-md-6">
        <div class="inputBlock instFechaFaseOM">
          <mat-label>{{
            "cebe.generalData.contractData.datePhaseOm" | translate
          }}</mat-label>
          <div class="datepicker-container instFechaFaseOM">
            <input
              matInput
              class="dateInput"
              [matDatepicker]="pickerFaseOm"
              formControlName="faseOMFecha"
              [disabled]="!this.cebe.edicionCebe"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="pickerFaseOm"
            ></mat-datepicker-toggle>
            <mat-datepicker #pickerFaseOm></mat-datepicker>
          </div>
        </div>
        <div class="inputBlock instResponsablePagoOM select-container">
          <mat-label>{{
            "cebe.generalData.contractData.responsibleElecPaymentOM" | translate
          }}</mat-label>
          <mat-select
            class="dataInput"
            formControlName="resPagoElecOmID"
            [disabled]="!this.cebe.edicionCebe"
          >
            <mat-option
              *ngFor="let item of tipoPagoElecOMList"
              [value]="item.id"
            >
              {{ "energy.payments." + item.codigo | translate }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </form>
</div>
